export default __webpack_public_path__ + "static/media/Icon_Chat.1c1529f3.svg";